import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  $textcolor?: string;
}

export const MainGnbMenuBarItem = styled.div<IProps>`
  .area-click {
    transition: color 0.3s;
    font-weight: 600;
    line-height: 130%;
    color: #999;
    height: 100%;
    font-size: 15px;
    padding: 4px 6px;
    -webkit-user-select: none;
    user-select: none;
    gap: 2px;
  }

  .ad-tag {
    display: inline-block;
    color: #999;
    font-size: 11px;
    font-weight: 400;
    line-height: 130%;
    padding: 0 0 5px 0;
  }

  .mnbrtm-inner {
    &.type-image {
      .img {
        width: 65px;
        height: 19px;
      }
    }

    &.type-lottie {
      width: 65px;
      height: 19px;

      > div {
        width: 100%;
        height: 100%;
      }
    }
  }

  &.dot .area-click::after {
    content: '';
    display: inline-block;
    border-radius: 50%;
    background-color: #fa5500;
    width: 4px;
    height: 4px;
    transform: translateY(-8px);
  }

  ${props => {
    if (typeof props.$textcolor === 'string' && props.$textcolor !== '') {
      return css`
        .area-click {
          color: ${props.$textcolor};
        }

        &.active {
          .area-click {
            background-color: ${props.$textcolor} !important;
          }
        }
      `;
    }
    return null;
  }}

  @media ${({ theme }) => theme.media.smMax} {
    .area-click {
      font-size: ${mixin.pxToVw('15')};
      padding: ${mixin.pxToVw('4 6')};
      gap: ${mixin.pxToVw('2')};
    }

    .ad-tag {
      font-size: ${mixin.pxToVw('11')};
      padding: ${mixin.pxToVw('0 0 5 0')};
    }

    .mnbrtm-inner {
      &.type-image {
        img {
          width: ${mixin.pxToVw('65')};
          height: ${mixin.pxToVw('19')};
        }
      }
      &.type-lottie {
        width: ${mixin.pxToVw('65')};
        height: ${mixin.pxToVw('19')};
      }
    }

    &.dot .area-click::after {
      width: ${mixin.pxToVw('4')};
      height: ${mixin.pxToVw('4')};
      transform: translateY(${mixin.pxToVw('-8')});
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .mnbrtm-inner {
      &.type-image {
        .img {
          width: 72px;
          height: 22px;
        }
      }

      &.type-lottie {
        width: 72px;
        height: 22px;
      }
    }
  }
`;
